// extracted by mini-css-extract-plugin
export default {"image":"Speaker_image__3pqAP","name":"Speaker_name__j1Zyv","description":"Speaker_description__idNgr","link":"Speaker_link__rxjq6"};